<template>
  <div id="app">
    <Header />
    <Banner />
    <Submission v-if="shouldShowSubmission" />
    <Loading v-if="false" />
    <router-view v-if="true" class="view" />
    <Footer v-if="true" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { constantsComputed } from '@/store/helpers'
const Loading = () => import('@/components/Loading/Page')
const Header = () => import('@/components/Header/Main')
const Banner = () => import('@/components/Banner/Main')
const Submission = () => import('@/components/Submission/Main')
const Footer = () => import('@/components/Footer/Main')

export default {
  components: {
    Loading,
    Header,
    Banner,
    Submission,
    Footer
  },

  data () {
    return {}
  },

  computed: {
    ...constantsComputed,
    ...mapState({
      loadBanner: state => state.banner.isLoading,
      loadSponsor: state => state.sponsor.isLoading
    }),

    shouldShowSubmission () {
      const submissionBtn = this.configMap.get('submissionBtn')
      const urlAward = this.$route.path.includes('awards')
      if (!urlAward) return false
      if (!submissionBtn) return false
      return submissionBtn.isDisplay
    }
  },

  watch: {
    $route () {
      window.scrollTo(0, 0)
      this.$store.dispatch('banner/get', this.$route.name)
      this.$store.dispatch('symposium/setIsSymposium', this.$route.name)

      if (
        this.$route.name !== 'symposium_video' &&
        this.$route.name !== 'symposium_video_detail'
      ) {
        sessionStorage.removeItem('symposium_room_id_selected')
      }
    }
  },

  async beforeCreate () {
    await this.$store.dispatch('constants/getConfigs')
  },

  async created () {
    await this.$store.dispatch('symposium/setIsSymposium', this.$route.name)
  },

  mounted () {
    window.addEventListener('beforeunload', () => {
      sessionStorage.removeItem('symposium_room_id_selected')
    })
  }
}
</script>

<style lang="scss">
.view {
  animation: opacity 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

@keyframes opacity {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
